<div class="modal-container">
    <button
        id="modalVideo"
        #modalVideo
        data-bs-toggle="modal"
        data-bs-target="#modalVid"
        hidden="hidden">
        Launch
    </button>
    <div
        class="modal fade"
        id="modalVid"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="modalTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title h5-tipografia-govco">
                        {{"justino.modal-video-titulo" | translate}}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row align-items-center">
                        <iframe 
                            *ngIf="videoUrl" 
                            width="560" 
                            height="315" 
                            [src]="videoUrl" 
                            title="Funciones de Justino" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen>
                        </iframe>
                    </div>
                    <div class="row">
                        <div class="mt-3 d-flex gap-2 justify-content-center">
                            <button
                                type="button"
                                class="btn-govco btn-govco"
                                data-bs-dismiss="modal">
                              {{"justino.modal-video-saltar" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
